import axios from "../axios";
import { BASE_URL, initApi } from "../initApi";

// ----------------------- APP - ADMINCOMPANY - GET COMPANY
export async function company() {
  return initApi().then(() => {
    return axios.get(`${BASE_URL}/api/admin/company`);
  });
}
